var map = {
	"./0xbtc.svg": [
		88133,
		88133
	],
	"./1inch.svg": [
		43185,
		43185
	],
	"./1st.svg": [
		7724,
		7724
	],
	"./aave.svg": [
		54189,
		54189
	],
	"./abbc.svg": [
		85968,
		85968
	],
	"./abt.svg": [
		28623,
		28623
	],
	"./ac3.svg": [
		49651,
		49651
	],
	"./act.svg": [
		96684,
		96684
	],
	"./ada.svg": [
		80156,
		80156
	],
	"./adb.svg": [
		66127,
		66127
	],
	"./adx.svg": [
		43557,
		43557
	],
	"./ae.svg": [
		58142,
		58142
	],
	"./aeon.svg": [
		24249,
		24249
	],
	"./aergo.svg": [
		44330,
		44330
	],
	"./agi.svg": [
		92797,
		92797
	],
	"./aion.svg": [
		83605,
		83605
	],
	"./ait.svg": [
		67274,
		67274
	],
	"./akro.svg": [
		99921,
		99921
	],
	"./akt.svg": [
		93332,
		93332
	],
	"./aleph.svg": [
		93072,
		93072
	],
	"./algo.svg": [
		93089,
		93089
	],
	"./alis.svg": [
		89287,
		89287
	],
	"./alpha.svg": [
		75444,
		75444
	],
	"./alx.svg": [
		19741,
		19741
	],
	"./amb.svg": [
		40840,
		40840
	],
	"./amlt.svg": [
		15006,
		15006
	],
	"./ampl.svg": [
		7666,
		7666
	],
	"./anc.svg": [
		29772,
		29772
	],
	"./anj.svg": [
		86309,
		86309
	],
	"./ankr.svg": [
		97982,
		97982
	],
	"./ant.svg": [
		4483,
		4483
	],
	"./aph.svg": [
		40033,
		40033
	],
	"./apl.svg": [
		68925,
		68925
	],
	"./appc.svg": [
		47416,
		47416
	],
	"./apy.svg": [
		25152,
		25152
	],
	"./ar.svg": [
		40849,
		40849
	],
	"./ardr.svg": [
		2047,
		2047
	],
	"./ark.svg": [
		56232,
		56232
	],
	"./arn.svg": [
		30165,
		30165
	],
	"./aro.svg": [
		88180,
		88180
	],
	"./arrr.svg": [
		33425,
		33425
	],
	"./ast.svg": [
		22396,
		22396
	],
	"./atmi.svg": [
		96705,
		96705
	],
	"./atom.svg": [
		90947,
		90947
	],
	"./auc.svg": [
		43585,
		43585
	],
	"./aura.svg": [
		68401,
		68401
	],
	"./avax.svg": [
		40354,
		40354
	],
	"./awc.svg": [
		23447,
		23447
	],
	"./axp.svg": [
		97553,
		97553
	],
	"./bac.svg": [
		32302,
		32302
	],
	"./bal.svg": [
		62089,
		62089
	],
	"./bam.svg": [
		36728,
		36728
	],
	"./band.svg": [
		90909,
		90909
	],
	"./bao.svg": [
		922,
		922
	],
	"./bat.svg": [
		44353,
		44353
	],
	"./bay.svg": [
		85588,
		85588
	],
	"./bbr.svg": [
		47734,
		47734
	],
	"./bcd.svg": [
		78619,
		78619
	],
	"./bch.svg": [
		71759,
		71759
	],
	"./bcn.svg": [
		52737,
		52737
	],
	"./bco.svg": [
		54288,
		54288
	],
	"./bf.svg": [
		49280,
		49280
	],
	"./bifi.svg": [
		21432,
		21432
	],
	"./bix.svg": [
		53197,
		53197
	],
	"./block.svg": [
		28459,
		28459
	],
	"./blt.svg": [
		69882,
		69882
	],
	"./blue.svg": [
		83580,
		83580
	],
	"./blz.svg": [
		57612,
		57612
	],
	"./bnb.svg": [
		25706,
		25706
	],
	"./bnt.svg": [
		74788,
		74788
	],
	"./bond.svg": [
		77403,
		77403
	],
	"./bora.svg": [
		32010,
		32010
	],
	"./box.svg": [
		38595,
		38595
	],
	"./bpt.svg": [
		36798,
		36798
	],
	"./bqx.svg": [
		64069,
		64069
	],
	"./brd.svg": [
		88808,
		88808
	],
	"./btc++.svg": [
		25663,
		25663
	],
	"./btc.svg": [
		54365,
		54365
	],
	"./btcd.svg": [
		23403,
		23403
	],
	"./btcp.svg": [
		56519,
		56519
	],
	"./btg.svg": [
		85825,
		85825
	],
	"./btmx.svg": [
		87385,
		87385
	],
	"./bto.svg": [
		12089,
		12089
	],
	"./bts.svg": [
		53869,
		53869
	],
	"./btt.svg": [
		44578,
		44578
	],
	"./btu.svg": [
		58803,
		58803
	],
	"./bu.svg": [
		45475,
		45475
	],
	"./busd.svg": [
		56250,
		56250
	],
	"./bwt.svg": [
		57263,
		57263
	],
	"./bz.svg": [
		89044,
		89044
	],
	"./bznt.svg": [
		71530,
		71530
	],
	"./bzrx.svg": [
		70906,
		70906
	],
	"./c20.svg": [
		66097,
		66097
	],
	"./cake.svg": [
		11732,
		11732
	],
	"./capp.svg": [
		99176,
		99176
	],
	"./car.svg": [
		94506,
		94506
	],
	"./card.svg": [
		39770,
		39770
	],
	"./cbat.svg": [
		52124,
		52124
	],
	"./cbc.svg": [
		75842,
		75842
	],
	"./cbt.svg": [
		62333,
		62333
	],
	"./cccx.svg": [
		62263,
		62263
	],
	"./cdai.svg": [
		64091,
		64091
	],
	"./cdt.svg": [
		50064,
		27683
	],
	"./cel.svg": [
		68072,
		68072
	],
	"./celr.svg": [
		18442,
		18442
	],
	"./cennz.svg": [
		29898,
		29898
	],
	"./ceth.svg": [
		35544,
		35544
	],
	"./cfx.svg": [
		53117,
		53117
	],
	"./chai.svg": [
		38455,
		38455
	],
	"./chat.svg": [
		96114,
		96114
	],
	"./chsb.svg": [
		76786,
		76786
	],
	"./chz.svg": [
		30169,
		30169
	],
	"./ckb.svg": [
		91484,
		91484
	],
	"./clo.svg": [
		75808,
		75808
	],
	"./cloak.svg": [
		53128,
		53128
	],
	"./cmt.svg": [
		85976,
		85976
	],
	"./cnd.svg": [
		63425,
		63425
	],
	"./cnx.svg": [
		29733,
		29733
	],
	"./comp.svg": [
		41093,
		41093
	],
	"./coni.svg": [
		36901,
		36901
	],
	"./cosm.svg": [
		20166,
		20166
	],
	"./coti.svg": [
		65067,
		65067
	],
	"./cov.svg": [
		67164,
		67164
	],
	"./cova.svg": [
		69493,
		69493
	],
	"./cpc.svg": [
		51832,
		51832
	],
	"./cpx.svg": [
		4259,
		4259
	],
	"./cre.svg": [
		1148,
		1148
	],
	"./cream.svg": [
		57498,
		57498
	],
	"./cred.svg": [
		5032,
		5032
	],
	"./crep.svg": [
		43364,
		43364
	],
	"./cro.svg": [
		3734,
		3734
	],
	"./crpt.svg": [
		49260,
		26879
	],
	"./crv.svg": [
		56415,
		56415
	],
	"./cs.svg": [
		72314,
		72314
	],
	"./csai.svg": [
		31180,
		31180
	],
	"./csc.svg": [
		91317,
		91317
	],
	"./ctc.svg": [
		77884,
		77884
	],
	"./ctxc.svg": [
		10422,
		10422
	],
	"./cube.svg": [
		37167,
		37167
	],
	"./cusdc.svg": [
		35392,
		35392
	],
	"./cv.svg": [
		72343,
		72343
	],
	"./cvc.svg": [
		90518,
		90518
	],
	"./cvt.svg": [
		65673,
		65673
	],
	"./cwbtc.svg": [
		71103,
		71103
	],
	"./czrx.svg": [
		86198,
		63817
	],
	"./dadi.svg": [
		15360,
		15360
	],
	"./dag.svg": [
		18384,
		18384
	],
	"./dai.svg": [
		35734,
		35734
	],
	"./dasc.svg": [
		64663,
		64663
	],
	"./dash.svg": [
		76044,
		76044
	],
	"./dat.svg": [
		55635,
		55635
	],
	"./data.svg": [
		2472,
		2472
	],
	"./datx.svg": [
		80753,
		80753
	],
	"./dbc.svg": [
		7977,
		7977
	],
	"./dcc.svg": [
		71350,
		71350
	],
	"./dcn.svg": [
		3747,
		3747
	],
	"./dcr.svg": [
		40503,
		40503
	],
	"./dct.svg": [
		55561,
		55561
	],
	"./ddd.svg": [
		80276,
		80276
	],
	"./default.svg": [
		80663
	],
	"./dent.svg": [
		44907,
		44907
	],
	"./dfi.svg": [
		72975,
		72975
	],
	"./dft.svg": [
		96250,
		96250
	],
	"./dgb.svg": [
		14083,
		14083
	],
	"./dgd.svg": [
		10077,
		10077
	],
	"./dgtx.svg": [
		25983,
		25983
	],
	"./divi.svg": [
		27938,
		27938
	],
	"./dlt.svg": [
		5308,
		5308
	],
	"./dmt.svg": [
		73535,
		73535
	],
	"./dnt.svg": [
		50642,
		50642
	],
	"./dock.svg": [
		58573,
		58573
	],
	"./dodo.svg": [
		38456,
		38456
	],
	"./doge.svg": [
		83111,
		83111
	],
	"./dor.svg": [
		11179,
		11179
	],
	"./dot.svg": [
		40837,
		40837
	],
	"./drgn.svg": [
		50601,
		50601
	],
	"./drop.svg": [
		9767,
		9767
	],
	"./dta.svg": [
		25161,
		25161
	],
	"./dtr.svg": [
		5962,
		5962
	],
	"./dtx.svg": [
		85680,
		85680
	],
	"./dxt.svg": [
		92216,
		92216
	],
	"./edg.svg": [
		76942,
		76942
	],
	"./edo.svg": [
		77286,
		77286
	],
	"./efx.svg": [
		18771,
		18771
	],
	"./egld.svg": [
		87032,
		87032
	],
	"./egt.svg": [
		56404,
		56404
	],
	"./ekg.svg": [
		68091,
		68091
	],
	"./ekt.svg": [
		57880,
		57880
	],
	"./ela.svg": [
		10296,
		10296
	],
	"./elec.svg": [
		15903,
		15903
	],
	"./elf.svg": [
		55223,
		55223
	],
	"./emc.svg": [
		66077,
		66077
	],
	"./emc2.svg": [
		1173,
		1173
	],
	"./eng.svg": [
		13164,
		13164
	],
	"./enj.svg": [
		489,
		489
	],
	"./eos.svg": [
		51699,
		51699
	],
	"./eosdac.svg": [
		96865,
		96865
	],
	"./erd.svg": [
		73443,
		73443
	],
	"./ern.svg": [
		58233,
		58233
	],
	"./esd.svg": [
		12704,
		12704
	],
	"./esp.svg": [
		27932,
		27932
	],
	"./ess.svg": [
		30255,
		30255
	],
	"./etc.svg": [
		25458,
		25458
	],
	"./eth.svg": [
		99289,
		99289
	],
	"./etn.svg": [
		94823,
		94823
	],
	"./etp.svg": [
		30001,
		30001
	],
	"./etz.svg": [
		61707,
		61707
	],
	"./evx.svg": [
		56035,
		56035
	],
	"./ewt.svg": [
		72708,
		72708
	],
	"./exrn.svg": [
		73787,
		73787
	],
	"./exy.svg": [
		98356,
		98356
	],
	"./fct.svg": [
		82159,
		82159
	],
	"./fet.svg": [
		72241,
		72241
	],
	"./fil.svg": [
		56626,
		34245
	],
	"./flow.svg": [
		81416,
		81416
	],
	"./fota.svg": [
		92760,
		92760
	],
	"./frm.svg": [
		20485,
		20485
	],
	"./fsn.svg": [
		62741,
		62741
	],
	"./ft.svg": [
		73518,
		73518
	],
	"./ftm.svg": [
		72071,
		72071
	],
	"./ftt.svg": [
		62670,
		62670
	],
	"./fuel.svg": [
		22532,
		22532
	],
	"./fun.svg": [
		81163,
		81163
	],
	"./fxc.svg": [
		58101,
		58101
	],
	"./fxt.svg": [
		68154,
		68154
	],
	"./gala.svg": [
		16049,
		16049
	],
	"./gdc.svg": [
		71920,
		71920
	],
	"./gem.svg": [
		60357,
		60357
	],
	"./gen.svg": [
		38841,
		61222
	],
	"./gno.svg": [
		17078,
		17078
	],
	"./gnt.svg": [
		42234,
		19853
	],
	"./gnx.svg": [
		1289,
		1289
	],
	"./go.svg": [
		86746,
		86746
	],
	"./goc.svg": [
		65685,
		65685
	],
	"./got.svg": [
		75738,
		75738
	],
	"./grin.svg": [
		17418,
		17418
	],
	"./grs.svg": [
		23854,
		23854
	],
	"./grt.svg": [
		35409,
		35409
	],
	"./gsc.svg": [
		87825,
		87825
	],
	"./gt.svg": [
		60801,
		60801
	],
	"./gtc.svg": [
		93152,
		93152
	],
	"./gto.svg": [
		2212,
		2212
	],
	"./gusd.svg": [
		45365,
		45365
	],
	"./gvt.svg": [
		4661,
		4661
	],
	"./gxs.svg": [
		95356,
		95356
	],
	"./hav.svg": [
		56965,
		56965
	],
	"./hbar.svg": [
		25943,
		25943
	],
	"./hc.svg": [
		34267,
		34267
	],
	"./hedg.svg": [
		43926,
		43926
	],
	"./her.svg": [
		73213,
		73213
	],
	"./hex.svg": [
		33767,
		33767
	],
	"./hive.svg": [
		1722,
		1722
	],
	"./hot-x.svg": [
		78306,
		78306
	],
	"./hot.svg": [
		1073,
		1073
	],
	"./hpb.svg": [
		31850,
		31850
	],
	"./hsr.svg": [
		20467,
		20467
	],
	"./ht.svg": [
		74884,
		74884
	],
	"./hum.svg": [
		72298,
		72298
	],
	"./husd.svg": [
		61432,
		61432
	],
	"./hvn.svg": [
		6476,
		6476
	],
	"./hydro.svg": [
		50586,
		50586
	],
	"./hyn.svg": [
		68277,
		68277
	],
	"./ibat.svg": [
		16922,
		16922
	],
	"./icn.svg": [
		12670,
		12670
	],
	"./icx.svg": [
		15168,
		15168
	],
	"./idai.svg": [
		28853,
		28853
	],
	"./idex.svg": [
		38224,
		38224
	],
	"./ieth.svg": [
		15218,
		15218
	],
	"./ignis.svg": [
		10414,
		10414
	],
	"./iknc.svg": [
		18633,
		18633
	],
	"./ilink.svg": [
		67549,
		67549
	],
	"./inb.svg": [
		46389,
		46389
	],
	"./ins.svg": [
		73700,
		73700
	],
	"./iost.svg": [
		73209,
		73209
	],
	"./iota.svg": [
		27049,
		27049
	],
	"./iotx.svg": [
		18192,
		18192
	],
	"./iq.svg": [
		94602,
		94602
	],
	"./irep.svg": [
		89818,
		89818
	],
	"./iris.svg": [
		17197,
		17197
	],
	"./isusd.svg": [
		75912,
		75912
	],
	"./iusdc.svg": [
		16406,
		16406
	],
	"./iwbtc.svg": [
		91153,
		91153
	],
	"./izrx.svg": [
		88443,
		88443
	],
	"./jnt.svg": [
		4140,
		4140
	],
	"./jrt.svg": [
		81552,
		81552
	],
	"./jst.svg": [
		65331,
		65331
	],
	"./kava.svg": [
		29603,
		29603
	],
	"./kcs.svg": [
		12909,
		12909
	],
	"./keep.svg": [
		60747,
		60747
	],
	"./key.svg": [
		8877,
		8877
	],
	"./kick.svg": [
		35882,
		35882
	],
	"./kin.svg": [
		26542,
		26542
	],
	"./klv.svg": [
		84257,
		84257
	],
	"./kmd.svg": [
		17904,
		17904
	],
	"./knc.svg": [
		67366,
		67366
	],
	"./ksm.svg": [
		1707,
		1707
	],
	"./lamb.svg": [
		79324,
		79324
	],
	"./land.svg": [
		52383,
		52383
	],
	"./lba.svg": [
		13091,
		13091
	],
	"./ldo.svg": [
		19511,
		19511
	],
	"./lend.svg": [
		36211,
		36211
	],
	"./leo.svg": [
		90260,
		90260
	],
	"./link.svg": [
		31920,
		31920
	],
	"./lit.svg": [
		8755,
		8755
	],
	"./lky.svg": [
		76556,
		76556
	],
	"./loki.svg": [
		67167,
		67167
	],
	"./lon.svg": [
		98631,
		98631
	],
	"./loom.svg": [
		18383,
		18383
	],
	"./lpt.svg": [
		41336,
		41336
	],
	"./lqd.svg": [
		34283,
		34283
	],
	"./lrc.svg": [
		97105,
		97105
	],
	"./lsk.svg": [
		22390,
		22390
	],
	"./ltc.svg": [
		4099,
		4099
	],
	"./lto.svg": [
		19175,
		19175
	],
	"./lun.svg": [
		15685,
		15685
	],
	"./luna.svg": [
		70206,
		70206
	],
	"./lxt.svg": [
		75648,
		75648
	],
	"./lym.svg": [
		16442,
		16442
	],
	"./maid.svg": [
		97533,
		97533
	],
	"./man.svg": [
		48676,
		48676
	],
	"./mana-old.svg": [
		82497,
		82497
	],
	"./mana.svg": [
		43149,
		43149
	],
	"./math.svg": [
		88890,
		88890
	],
	"./matic.svg": [
		44050,
		44050
	],
	"./mbc.svg": [
		51588,
		51588
	],
	"./mco.svg": [
		59427,
		59427
	],
	"./mcx.svg": [
		30860,
		30860
	],
	"./mda.svg": [
		59416,
		59416
	],
	"./mds.svg": [
		44458,
		44458
	],
	"./med.svg": [
		60146,
		60146
	],
	"./medx.svg": [
		57222,
		57222
	],
	"./met.svg": [
		7586,
		7586
	],
	"./mfg.svg": [
		41164,
		41164
	],
	"./mft.svg": [
		20271,
		20271
	],
	"./mir.svg": [
		93560,
		93560
	],
	"./mith.svg": [
		30722,
		30722
	],
	"./mkr.svg": [
		16398,
		16398
	],
	"./mln.svg": [
		98935,
		98935
	],
	"./mod.svg": [
		90788,
		90788
	],
	"./mot.svg": [
		32820,
		32820
	],
	"./mta.svg": [
		31944,
		31944
	],
	"./mth.svg": [
		87425,
		87425
	],
	"./mtl.svg": [
		16317,
		16317
	],
	"./mtn.svg": [
		41071,
		41071
	],
	"./mvc.svg": [
		46864,
		46864
	],
	"./mvl.svg": [
		27431,
		27431
	],
	"./mvp.svg": [
		18291,
		18291
	],
	"./mwat.svg": [
		9791,
		9791
	],
	"./mwc.svg": [
		93088,
		70707
	],
	"./mxm.svg": [
		27536,
		27536
	],
	"./myb.svg": [
		70776,
		70776
	],
	"./nano.svg": [
		42242,
		42242
	],
	"./nas.svg": [
		87746,
		87746
	],
	"./nav.svg": [
		38047,
		38047
	],
	"./ncash.svg": [
		65575,
		65575
	],
	"./nct.svg": [
		82791,
		82791
	],
	"./near.svg": [
		46766,
		46766
	],
	"./nebl.svg": [
		85169,
		85169
	],
	"./nec.svg": [
		80150,
		80150
	],
	"./neo.svg": [
		97906,
		97906
	],
	"./new.svg": [
		15098,
		15098
	],
	"./nex.svg": [
		6221,
		6221
	],
	"./nexo.svg": [
		97744,
		97744
	],
	"./nexxo.svg": [
		69914,
		69914
	],
	"./ngc.svg": [
		84476,
		84476
	],
	"./nkn.svg": [
		40725,
		40725
	],
	"./nmr.svg": [
		2319,
		2319
	],
	"./noia.svg": [
		99987,
		99987
	],
	"./nper.svg": [
		87059,
		87059
	],
	"./npxs.svg": [
		4225,
		4225
	],
	"./nrg.svg": [
		57431,
		57431
	],
	"./nrve.svg": [
		77639,
		77639
	],
	"./nu.svg": [
		16903,
		16903
	],
	"./nuls.svg": [
		77792,
		77792
	],
	"./nxs.svg": [
		48301,
		48301
	],
	"./nxt.svg": [
		78082,
		78082
	],
	"./oag.svg": [
		34595,
		34595
	],
	"./oax.svg": [
		70756,
		70756
	],
	"./ocean.svg": [
		40090,
		40090
	],
	"./ocn.svg": [
		46716,
		46716
	],
	"./ode.svg": [
		1526,
		1526
	],
	"./ogn.svg": [
		25472,
		25472
	],
	"./okb.svg": [
		93568,
		93568
	],
	"./olt.svg": [
		4847,
		4847
	],
	"./omg.svg": [
		52015,
		52015
	],
	"./one.svg": [
		52100,
		52100
	],
	"./onion.svg": [
		56867,
		56867
	],
	"./ont.svg": [
		8437,
		8437
	],
	"./open.svg": [
		4712,
		4712
	],
	"./orbs.svg": [
		5910,
		5910
	],
	"./orc.svg": [
		45814,
		45814
	],
	"./orn.svg": [
		1507,
		1507
	],
	"./ost.svg": [
		98230,
		98230
	],
	"./ovc.svg": [
		16229,
		38610
	],
	"./oxt.svg": [
		8811,
		8811
	],
	"./pBTC.svg": [
		9997,
		9997
	],
	"./pai.svg": [
		56762,
		56762
	],
	"./pal.svg": [
		1911,
		1911
	],
	"./part.svg": [
		72239,
		72239
	],
	"./pax.svg": [
		56699,
		56699
	],
	"./paxg.svg": [
		95662,
		95662
	],
	"./pay.svg": [
		14730,
		14730
	],
	"./perl.svg": [
		86635,
		86635
	],
	"./pivx.svg": [
		68759,
		68759
	],
	"./plDAI.svg": [
		93530,
		93530
	],
	"./plUSDC.svg": [
		96343,
		96343
	],
	"./play.svg": [
		59006,
		59006
	],
	"./plr.svg": [
		79534,
		79534
	],
	"./png.svg": [
		41653,
		41653
	],
	"./pnk.svg": [
		64321,
		64321
	],
	"./pnt.svg": [
		24550,
		24550
	],
	"./poa.svg": [
		77988,
		77988
	],
	"./poe.svg": [
		3864,
		3864
	],
	"./poly.svg": [
		43706,
		43706
	],
	"./pond.svg": [
		22741,
		22741
	],
	"./powr.svg": [
		97460,
		97460
	],
	"./ppay.svg": [
		85370,
		85370
	],
	"./ppc.svg": [
		76371,
		76371
	],
	"./ppp.svg": [
		39120,
		39120
	],
	"./ppt.svg": [
		46940,
		46940
	],
	"./pre.svg": [
		29811,
		29811
	],
	"./prl.svg": [
		8186,
		8186
	],
	"./pro.svg": [
		76297,
		76297
	],
	"./prq.svg": [
		33327,
		33327
	],
	"./pst.svg": [
		33221,
		33221
	],
	"./qash.svg": [
		23167,
		23167
	],
	"./qbit.svg": [
		94621,
		17002
	],
	"./qkc.svg": [
		16955,
		16955
	],
	"./qlc.svg": [
		81910,
		81910
	],
	"./qnt.svg": [
		66195,
		66195
	],
	"./qsp.svg": [
		5856,
		5856
	],
	"./qtum.svg": [
		95013,
		95013
	],
	"./r.svg": [
		7954,
		7954
	],
	"./rae.svg": [
		81168,
		81168
	],
	"./rari.svg": [
		47940,
		47940
	],
	"./ray.svg": [
		62468,
		62468
	],
	"./rcn.svg": [
		43249,
		43249
	],
	"./rdd.svg": [
		42706,
		42706
	],
	"./rdn.svg": [
		92264,
		92264
	],
	"./ren.svg": [
		31071,
		31071
	],
	"./rep.svg": [
		27897,
		27897
	],
	"./req.svg": [
		15528,
		15528
	],
	"./rev.svg": [
		17927,
		17927
	],
	"./rfox.svg": [
		6045,
		6045
	],
	"./rhoc.svg": [
		66724,
		66724
	],
	"./rif.svg": [
		12043,
		12043
	],
	"./rlc.svg": [
		98917,
		98917
	],
	"./rose.svg": [
		44885,
		44885
	],
	"./rpx.svg": [
		51962,
		51962
	],
	"./rsr.svg": [
		38437,
		38437
	],
	"./rsv.svg": [
		41897,
		41897
	],
	"./rune.svg": [
		48080,
		48080
	],
	"./rvn.svg": [
		74086,
		74086
	],
	"./s.svg": [
		22595,
		22595
	],
	"./sai.svg": [
		8097,
		8097
	],
	"./salt.svg": [
		6552,
		6552
	],
	"./san.svg": [
		48190,
		48190
	],
	"./scrl.svg": [
		37976,
		37976
	],
	"./scrt.svg": [
		33360,
		33360
	],
	"./seele.svg": [
		53304,
		53304
	],
	"./sem.svg": [
		45769,
		45769
	],
	"./sfp.svg": [
		59301,
		59301
	],
	"./shr.svg": [
		40561,
		40561
	],
	"./shuf.svg": [
		35388,
		35388
	],
	"./sia.svg": [
		92977,
		92977
	],
	"./skl.svg": [
		40794,
		40794
	],
	"./sky.svg": [
		76615,
		76615
	],
	"./slt.svg": [
		54987,
		54987
	],
	"./smart.svg": [
		52683,
		52683
	],
	"./snc.svg": [
		17838,
		17838
	],
	"./sngls.svg": [
		69861,
		69861
	],
	"./snm.svg": [
		52888,
		52888
	],
	"./snt.svg": [
		60513,
		60513
	],
	"./snx.svg": [
		16053,
		16053
	],
	"./sol.svg": [
		18806,
		18806
	],
	"./soul.svg": [
		53289,
		53289
	],
	"./spn.svg": [
		56861,
		56861
	],
	"./srm.svg": [
		66788,
		66788
	],
	"./stake.svg": [
		57430,
		57430
	],
	"./steem.svg": [
		58844,
		58844
	],
	"./steth.svg": [
		88214,
		88214
	],
	"./stmx.svg": [
		46798,
		46798
	],
	"./storj.svg": [
		48988,
		48988
	],
	"./storm.svg": [
		76643,
		76643
	],
	"./strat.svg": [
		73014,
		73014
	],
	"./stx.svg": [
		90375,
		90375
	],
	"./sub.svg": [
		71614,
		71614
	],
	"./super.svg": [
		3353,
		3353
	],
	"./suqa.svg": [
		40470,
		40470
	],
	"./sushi.svg": [
		11766,
		11766
	],
	"./suter.svg": [
		72453,
		72453
	],
	"./swap.svg": [
		72033,
		72033
	],
	"./swth.svg": [
		81346,
		81346
	],
	"./sxdt.svg": [
		6689,
		6689
	],
	"./sxp.svg": [
		88323,
		88323
	],
	"./sys.svg": [
		563,
		563
	],
	"./tct.svg": [
		19449,
		19449
	],
	"./tel.svg": [
		96303,
		96303
	],
	"./tfuel.svg": [
		53088,
		53088
	],
	"./thc.svg": [
		28967,
		28967
	],
	"./theta.svg": [
		78676,
		78676
	],
	"./thr.svg": [
		19910,
		19910
	],
	"./tio.svg": [
		89088,
		89088
	],
	"./titan.svg": [
		83238,
		83238
	],
	"./tkn.svg": [
		74843,
		74843
	],
	"./tky.svg": [
		34372,
		34372
	],
	"./tnb.svg": [
		3644,
		3644
	],
	"./tnc.svg": [
		32189,
		32189
	],
	"./tnt.svg": [
		45698,
		45698
	],
	"./tomo.svg": [
		55859,
		55859
	],
	"./tpay.svg": [
		7150,
		7150
	],
	"./trac.svg": [
		42066,
		42066
	],
	"./trb.svg": [
		8888,
		8888
	],
	"./trig.svg": [
		45942,
		45942
	],
	"./trtl.svg": [
		99742,
		99742
	],
	"./trx.svg": [
		34770,
		34770
	],
	"./tryb.svg": [
		9944,
		87563
	],
	"./ttc.svg": [
		99643,
		99643
	],
	"./tube.svg": [
		68198,
		68198
	],
	"./tusd.svg": [
		18660,
		18660
	],
	"./ubq.svg": [
		39918,
		39918
	],
	"./ubt.svg": [
		55571,
		55571
	],
	"./ult.svg": [
		68805,
		68805
	],
	"./uma.svg": [
		43711,
		43711
	],
	"./unfi.svg": [
		48142,
		48142
	],
	"./uni.svg": [
		68426,
		68426
	],
	"./unn.svg": [
		78837,
		78837
	],
	"./uos.svg": [
		45699,
		45699
	],
	"./upp.svg": [
		4949,
		4949
	],
	"./usd.svg": [
		61904,
		61904
	],
	"./usdc.svg": [
		50883,
		50883
	],
	"./usds.svg": [
		72563,
		72563
	],
	"./usdt.svg": [
		38668,
		38668
	],
	"./utk.svg": [
		38714,
		38714
	],
	"./uuu.svg": [
		57915,
		57915
	],
	"./veri.svg": [
		97684,
		97684
	],
	"./vest.svg": [
		79582,
		79582
	],
	"./vet.svg": [
		93025,
		93025
	],
	"./via.svg": [
		45712,
		45712
	],
	"./vib.svg": [
		11811,
		11811
	],
	"./vibe.svg": [
		97668,
		97668
	],
	"./vidt.svg": [
		82811,
		82811
	],
	"./vikky.svg": [
		36558,
		36558
	],
	"./vin.svg": [
		26279,
		26279
	],
	"./vite.svg": [
		88682,
		88682
	],
	"./viu.svg": [
		76748,
		76748
	],
	"./vlx.svg": [
		78322,
		78322
	],
	"./vrs.svg": [
		99283,
		99283
	],
	"./vsp.svg": [
		54563,
		54563
	],
	"./vsys.svg": [
		33141,
		33141
	],
	"./vtc.svg": [
		57233,
		57233
	],
	"./wabi.svg": [
		52483,
		52483
	],
	"./wan.svg": [
		53586,
		53586
	],
	"./waves.svg": [
		53394,
		53394
	],
	"./wbtc.svg": [
		69616,
		69616
	],
	"./wct.svg": [
		67486,
		67486
	],
	"./whale.svg": [
		25575,
		25575
	],
	"./wib.svg": [
		12318,
		12318
	],
	"./wings.svg": [
		38024,
		38024
	],
	"./woo.svg": [
		881,
		881
	],
	"./wpr.svg": [
		50322,
		27941
	],
	"./wrx.svg": [
		21557,
		21557
	],
	"./wtc.svg": [
		24816,
		24816
	],
	"./wxt.svg": [
		75891,
		75891
	],
	"./xas.svg": [
		32264,
		32264
	],
	"./xchf.svg": [
		12533,
		12533
	],
	"./xem.svg": [
		91946,
		91946
	],
	"./xin.svg": [
		11221,
		11221
	],
	"./xlm.svg": [
		39025,
		39025
	],
	"./xlq.svg": [
		57973,
		57973
	],
	"./xmark.svg": [
		5187,
		5187
	],
	"./xmr.svg": [
		10885,
		10885
	],
	"./xmx.svg": [
		66015,
		66015
	],
	"./xnk.svg": [
		67257,
		67257
	],
	"./xns.svg": [
		67345,
		67345
	],
	"./xor.svg": [
		23343,
		23343
	],
	"./xrp.svg": [
		33846,
		33846
	],
	"./xsn.svg": [
		74679,
		74679
	],
	"./xsr.svg": [
		37923,
		37923
	],
	"./xtz.svg": [
		7878,
		7878
	],
	"./xvg.svg": [
		97941,
		97941
	],
	"./xyo.svg": [
		41668,
		41668
	],
	"./xzc.svg": [
		49085,
		49085
	],
	"./yfi.svg": [
		1478,
		1478
	],
	"./yoyo.svg": [
		29744,
		29744
	],
	"./zai.svg": [
		76540,
		76540
	],
	"./zb.svg": [
		68548,
		68548
	],
	"./zco.svg": [
		21896,
		21896
	],
	"./zec.svg": [
		80370,
		80370
	],
	"./zel.svg": [
		48277,
		48277
	],
	"./zen.svg": [
		74855,
		74855
	],
	"./zil.svg": [
		66505,
		66505
	],
	"./zks.svg": [
		25508,
		25508
	],
	"./zrx.svg": [
		52484,
		52484
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 70459;
module.exports = webpackAsyncContext;